var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-wrap"},[_c('div',{staticClass:"icon-up"}),_c('p',{staticClass:"desc"},[_vm._v("看到最后一页查奖品")])])}]

export { render, staticRenderFns }